export class Search {
	
	constructor() {
		let url = new URL(window.location.href);
		this.mid = 4;
		this.id = 0;
	}

	submit(parent) {
		let _this = this;
		
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + this.mid + '/',
			dataType: 'html',
			data: $(parent).serialize() + '&action=load',
			success: function(data)
			{
				$('#cards_result').replaceWith(data);
				_this.applyEvents();
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	toggleAll(parent)
	{
		$('.allpbspb-card__choice-input').prop('checked', $(parent).prop('checked'));
	}

	setDates(parent, type)
	{
		let date1 = new Date();
		let date2 = new Date();
		if (type == 'week')
			date1.setDate(date2.getDate() - 7);
		if (type == 'month')
			date1.setDate(date2.getDate() - 30);

		let period = date1.toLocaleDateString() + ' — ' + date2.toLocaleDateString();

		$(parent).closest('.form-item__main').find('.form-date__input--range').val(period).trigger('change');
	}

	applyEvents()
	{
		let _this = this;

		$('#search_card_all').on("click", function(){
			_this.toggleAll(this);
		})

		$(".allpbspb-objects__open-actions-popup").on("click", function () {
			// let dataTypeName = $(this).attr("data-type-for");
			$(".allpbspb-objects__open-actions-popup").not(this).siblings(".allpbspb-objects__actions-popup").removeClass("active");
			$(this).siblings(".allpbspb-objects__actions-popup").toggleClass("active");

			// $(".allpbspb-objects__actions-popup[data-type!=" + dataTypeName + "]").removeClass("active");
			// $(".allpbspb-objects__actions-popup[data-type=" + dataTypeName + "]").toggleClass("active");
		});

		$('.form-date__links a:first-child').click(function(){search.setDates(this, 'month'); return false;});
		$('.form-date__links a:last-child').click(function(){search.setDates(this, 'week'); return false;});
	}

	resetFrom()
	{
		$('.form-multi__result-list').html('');
	}

	changePage(p, par)
	{
		$('form.form .hidden-page-num[name=' + par + ']').val(p);
		this.submit($('form.form'));
	}
}